import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  list ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnStatus/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnStatus/findById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteById ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnStatus/deleteById`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  saveOrUpdate ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnStatus/saveOrUpdate`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  updatePushStatus ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`learnStatus/updatePushStatus`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDataInfomation ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`learnStatus/getDataInfomation`, { params })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
